import addError from '../../../utils/error.jsx';


export function request() {
    return {
        type: 'LADDERS_GET_LIST_REQUEST'
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'LADDERS_GET_LIST_ERROR',
        errors
    };
}

export function finish(ladders) {
    return {
        type: 'LADDERS_GET_LIST_FINISH',
        ladders
    };
}
